import { CategoryEditModal } from '@/components/categories/CategoryEditModal';
import useCategories from '@/hooks/use-categories';
import useCategoryColor from '@/hooks/use-category-color';
import { Pencil, Sparkles, Tag } from 'lucide-react';
import { useState } from 'react';

export default function CategoryBadge({
  categoryId,
  transactionId,
  allowEdit,
  hasAppliedRule,
  onCategoryUpdated,
}: {
  categoryId?: string;
  transactionId?: string;
  allowEdit?: boolean;
  hasAppliedRule?: boolean;
  onCategoryUpdated?: (newCategoryId?: string) => void;
}) {
  const [isEditModalOpen, setisEditModalOpen] = useState(false);
  const categoriesMap = useCategories().categoriesMap;
  const name = categoryId ? categoriesMap[categoryId]?.name : 'Uncategorized';
  const colorInfo = useCategoryColor(categoryId);
  return (
    <>
      <div
        onClick={() => {
          if (allowEdit) {
            setisEditModalOpen(true);
          }
        }}
        className='inline-flex items-center gap-1 px-2 py-1 rounded-md text-xs font-medium'
        style={{
          backgroundColor: colorInfo.bg,
          color: colorInfo.text,
        }}
      >
        {hasAppliedRule ? (
          <Sparkles className='h-3 w-3' />
        ) : (
          <Tag className='h-3 w-3' />
        )}
        {name || 'Uncategorized'}
        {allowEdit && <Pencil className='w-3 h-3' />}
      </div>
      {!!transactionId && (
        <CategoryEditModal
          isOpen={isEditModalOpen}
          onClose={() => setisEditModalOpen(false)}
          transactionId={transactionId}
          currentCategoryId={categoryId}
          onCategoryUpdated={(newCategoryId) => {
            setisEditModalOpen(false);
            onCategoryUpdated?.(newCategoryId);
          }}
        />
      )}
    </>
  );
}
